import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledButtonProps } from './BottomBar.types';

export const StyledArrow = styled.span`
  display: inline-block;
  margin-left: ${rem('12px')};
  transform: rotate(180deg);

  svg {
    display: block;
    width: ${rem('11px')};
    height: auto;

    path {
      fill: ${({ theme }) => theme.colors.main};
    }
  }
`;

export const StyledButton = styled.button<IStyledButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => rem(theme.spacings.s)};
  color: ${({ theme }) => theme.colors.main};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  font-weight: 700;
  line-height: 1.4;
  text-decoration: none;
  background-color: ${({ theme, user }) => user && theme.colors[user].main};
  border: none;
  appearance: none;

  ${({ fixed, theme }) =>
    fixed &&
    `
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: ${theme.layers.bottomBar};
  `}
`;
